import React, { useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";

// Options pour le tri
const sortingOptions = ["Plus récents", "Plus anciens", "Date de début"];

// Options pour le statut
const statusOptions = ["Tous", "Ouvert", "Fermé"];

const Settings = ({ onFiltersChange }) => {
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [statusFilter, setStatusFilter] = useState(statusOptions[0]);

  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setStatusFilter(statusOptions[0]);
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        statusFilter: "tous"
      });
    }
  };

  const applyFilters = () => {
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        statusFilter: statusFilter === "Tous" ? "tous" : statusFilter
      });
    }
  };

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={statusFilter}
            setValue={setStatusFilter}
            options={statusOptions}
            label="Statut"
          />
        </div>
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
